import React from 'react';
import ItemInfo from './ItemInfo';

const Accessories = ({ item }) => {
    return (
        <div>
            <ItemInfo name={item.name} productId={item.productId} />
            <p className="margin-b15">This Product has no custom Options</p>
        </div>
    );
};

export default Accessories;
